import { Scale } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import type { ClaimWithRelations } from "../../api/use-claim";
import { usePutProcedure } from "../../api/use-claim-actions";
import { CtaShell } from "./cta-shell";

/** Port of states-cta/NumeroRG-CTA.vue — saisie du numéro RG de la procédure. */
export function NumeroRGCTA({ claim }: { claim: ClaimWithRelations }) {
  const [numeroRG, setNumeroRG] = useState("");
  const putProcedure = usePutProcedure(claim.id);

  function setProcedureIdentifier() {
    if (!numeroRG) {
      return;
    }
    putProcedure.mutate({ numeroRG });
  }

  return (
    <CtaShell legalStepName={claim.claimLegalStep.name}>
      <p className="mt-1 text-sm leading-6 text-gray-500">
        Saisir le numéro RG du dossier.
        <br />
        Pour synchroniser la claim avec le Tribunal Digital et recevoir des alertes.
      </p>

      <div className="relative block text-sm">
        <div className="py-6">
          <Label
            htmlFor="numero-rg"
            className="mb-1 flex items-center gap-1 text-sm font-medium text-gray-700"
          >
            <Scale className="h-4 w-4 text-gray-400" />
            Numéro RG
          </Label>
          <Input
            id="numero-rg"
            value={numeroRG}
            onChange={(e) => setNumeroRG(e.target.value)}
            placeholder="Example « 2023F00210 »"
          />
          <div className="mt-3">
            <Button onClick={setProcedureIdentifier} disabled={!numeroRG || putProcedure.isPending}>
              Sauvegarder
            </Button>
          </div>
        </div>
      </div>
    </CtaShell>
  );
}
